import React from 'react';
import swal from "sweetalert";
import FusionCharts from 'fusioncharts/core';
import Funnel from 'fusioncharts/viz/funnel';

FusionCharts.addDep(Funnel);

class VisitsFunnelChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            days: {},
            config: {},
            ctx: {}
        };
    }

    componentWillMount() {
        let self = this;
    }

    componentDidMount() {
        let self = this;
        let month_url = "";

        switch (month) {
            case "enero":
                month_url = "01";
                break;
            case "febrero":
                month_url = "02";
                break;
            case "marzo":
                month_url = "03";
                break;
            case "abril":
                month_url = "04";
                break;
            case "mayo":
                month_url = "05";
                break;
            case "junio":
                month_url = "06";
                break;
            case "julio":
                month_url = "07";
                break;
            case "agosto":
                month_url = "08";
                break;
            case "septiembre":
                month_url = "09";
                break;
            case "octubre":
                month_url = "10";
                break;
            case "noviembre":
                month_url = "11";
                break;
            case "diciembre":
                month_url = "12";
                break;
        }

        if (year < 2023) {
            swal({
                title: "¡Oh no!",
                text: "No se han obtenido resultados.",
                icon: "warning",
            });

            return;
        } else {
            
        }

        axios.get('/api/reports/' + month_url + '/' + year + '/conversion')
            .then(response => {
                let labels = response.data.labels;
                let values = response.data.count;

                let data = [];

                for (let i = 0; i < labels.length; i++) {
                    let data_json = {
                        label: labels[i],
                        value: values[i]
                    };

                    data.push(data_json);
                }

                FusionCharts.ready(function () {
                    let revenueChart = new FusionCharts({
                        type: 'funnel',
                        renderAt: 'conversion-chart',
                        width: '100%',
                        height: '80%',
                        dataFormat: 'json',
                        dataSource: {
                            "chart": {
                                "bgColor": "#ffffff",
                                "showValues": "1",
                                "plottooltext": "$label: $dataValue",
                                "showvalues": "1",
                                "decimals": "2",
                                "showpercentvalues": "1",
                                "borderThickness": "0",
                                "enableSmartLabels": true,
                            },
                            "data": data
                        }
                    }).render();

                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
    }

    render() {
        return (
            <div id='conversion-chart'></div>
        );
    }
}

export default VisitsFunnelChart;


// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/VisitsFunnelChart.jsx